export const getSubdomain = () => {
  const hostParts = window.location.hostname.split(".");
  if (hostParts.length > 1 && hostParts[hostParts.length - 1] === "localhost") {
    return hostParts[0];
  }
  if (hostParts.length > 2) {
    return hostParts[0];
  }
  return null; // or a default value
};
